export default __webpack_public_path__ + "static/media/473.0d231553.gif";